import { useState } from "react";
import { Link } from "react-router-dom";
import { AuthLayout } from "../../components/AuthLayout";
import { api } from "../../lib/api";

export function MagicLink() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [devLink, setDevLink] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function requestLink(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.post<{ ok: boolean; devLink?: string }>("/auth/magic/request", { email });
      setSent(true);
      setDevLink(res.devLink ?? null);
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthLayout
      posterTitle="No password, no problem."
      posterBody="A link is easier to type than a password with wet hands. It expires in fifteen minutes."
    >
      {!sent ? (
        <form onSubmit={requestLink}>
          <span className="eyebrow">Sign in without a password</span>
          <h2 style={{ margin: "12px 0 0", fontSize: 38, lineHeight: 1.05, letterSpacing: "-0.028em", marginLeft: "-0.055em" }}>
            Email me a link
          </h2>
          <div className="field" style={{ margin: "24px 0 24px" }}>
            <label>Email</label>
            <input className="input" style={{ minHeight: 44 }} type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <button className="btn btn-primary btn-block" style={{ minHeight: 48 }} disabled={busy} type="submit">
            {busy ? "Sending…" : "Send the link"}
          </button>
          <p className="muted" style={{ margin: "20px 0 0", fontSize: 13.5 }}>
            <Link to="/sign-in">Use a password instead</Link>
          </p>
        </form>
      ) : (
        <>
          <span className="eyebrow">Link sent · expires in 15 minutes</span>
          <h2 style={{ margin: "12px 0 0", fontSize: 38, lineHeight: 1.05, letterSpacing: "-0.028em", marginLeft: "-0.055em" }}>
            Check your email
          </h2>
          <p style={{ margin: "16px 0 0", fontSize: 15, lineHeight: 1.65 }} className="muted">
            We sent a sign-in link to <strong style={{ fontFamily: "var(--font-heading)", fontWeight: 800 }}>{email}</strong>.
            Open it on any device — the link signs you in and then stops working.
          </p>
          {devLink && (
            <div style={{ borderLeft: "2px solid var(--color-accent)", padding: "4px 0 4px 16px", margin: "28px 0" }}>
              <p className="muted" style={{ margin: "0 0 8px", fontSize: 13.5, lineHeight: 1.6 }}>
                No email server is configured for this dev environment, so here's the link directly:
              </p>
              <a href={devLink} style={{ fontSize: 13.5, wordBreak: "break-all" }}>
                {devLink}
              </a>
            </div>
          )}
          <div className="flex-row" style={{ marginTop: 24 }}>
            <button className="btn btn-secondary" onClick={() => setSent(false)} type="button">
              Send another
            </button>
            <Link to="/sign-in" className="btn btn-ghost" style={{ paddingLeft: 0 }}>
              Use a password instead
            </Link>
          </div>
        </>
      )}
    </AuthLayout>
  );
}
